import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../../App";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";

export default function AdminPasswordReset() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const nav = useNavigate();
  const [pwd, setPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (pwd !== confirmPwd) return toast.error("Passwords do not match");
    if (!/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{10,}$/.test(pwd))
      return toast.error("Use at least 10 characters with upper, lower and a number");
    setBusy(true);
    try {
      await axios.post(`${API}/admin/password-reset/confirm`, { token, new_password: pwd });
      toast.success("Password updated. Please sign in.");
      nav("/admin/login");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Reset failed");
    } finally { setBusy(false); }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center p-6">
        <div className="max-w-md text-center">
          <div className="text-[10px] kt-tracking-wider uppercase text-[#6F6B66] mb-3">KT Milano · Admin</div>
          <h1 className="font-serif text-2xl text-[#383633] mb-3">Invalid reset link</h1>
          <p className="text-sm text-[#6F6B66]">Please request a new reset link from the sign-in page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6">
      <div className="w-full max-w-md" data-testid="admin-reset">
        <div className="text-[10px] kt-tracking-wider uppercase text-[#6F6B66] mb-3">KT Milano · Admin</div>
        <h1 className="font-serif text-3xl text-[#383633] tracking-tight mb-6">Set a new password</h1>
        <div className="space-y-4 bg-white border kt-line rounded-2xl p-6 kt-shadow">
          <div>
            <Label className="text-xs kt-tracking uppercase text-[#6F6B66]">New password</Label>
            <Input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)}
              className="mt-2 h-11 border-[#ECE7DF]" data-testid="reset-new" />
          </div>
          <div>
            <Label className="text-xs kt-tracking uppercase text-[#6F6B66]">Confirm password</Label>
            <Input type="password" value={confirmPwd} onChange={(e) => setConfirmPwd(e.target.value)}
              className="mt-2 h-11 border-[#ECE7DF]" data-testid="reset-confirm" />
          </div>
          <Button onClick={submit} disabled={busy || !pwd || !confirmPwd} data-testid="reset-submit"
            className="w-full rounded-full h-12 bg-[#D8B589] hover:bg-[#C79E6E] text-[#3A2C1B] text-xs kt-tracking uppercase">
            {busy ? "Saving…" : "Update password"}
          </Button>
          <p className="text-[11px] text-[#6F6B66] leading-relaxed">
            Minimum 10 characters, including at least one uppercase letter, one lowercase letter and one number.
          </p>
        </div>
      </div>
    </div>
  );
}
